<template>
  <div
    :class="[
      'note-box',
      {
        'note-box--gray': color === 'gray',
        'note-box--blue': color === 'blue'
      }
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'NoteBox',
  props: {
    color: {
      type: String,
      default: 'gray'
    }
  }
}
</script>

<style lang="scss">
.note-box {
  padding: 1.2rem 1.4rem;
  font-size: 1rem;
  line-height: 1.45em;

  &--gray {
    background: $gray-100;
    font-style: italic;
  }

  &--blue {
    background: $gray-100;
    color: $gray-700;
  }
}
</style>
